export const iluminacaoConfig = [
  { id: "grupo01", modulo: "1", idx: "1", descricao: "Poste Externo", lightType: "normal", multipleInstances:[
    { x: 6, y: 44, width: 2.5, height: 5, circleNumber: 1 },
    { x: 2, y: 76, width: 2.5, height: 5, circleNumber: 1 },
    { x: 30.5, y: 93, width: 2.5, height: 5, circleNumber: 1 },
    { x: 63, y: 91, width: 2.5, height: 5, circleNumber: 1 },
    { x: 89, y: 91, width: 2.5, height: 5, circleNumber: 1 },
    { x: 89, y: 46, width: 2.5, height: 5, circleNumber: 1 },
    { x: 80.5, y: 15, width: 2.5, height: 5, circleNumber: 1 }

  ]},
  { id: "grupo02", modulo: "1", idx: "2", descricao: "Poste Externo 2", lightType: "normal", multipleInstances:[
    { x: 10, y: 44, width: 2.5, height: 5, circleNumber: 2 },
    { x: 5, y: 54, width: 2.5, height: 5, circleNumber: 2 },
    { x: 16, y: 93, width: 2.5, height: 5, circleNumber: 2 },
    { x: 44, y: 92, width: 2.5, height: 5, circleNumber: 2 },
    { x: 75, y: 91, width: 2.5, height: 5, circleNumber: 2 },
    { x: 96, y: 78, width: 2.5, height: 5, circleNumber: 2 },
    { x: 85, y: 31, width: 2.5, height: 5, circleNumber: 2 },
    { x: 76.5, y: 1, width: 2.5, height: 5, circleNumber: 2 },
  ]},
  { id: "grupo03", modulo: "1", idx: "3", descricao: "Balizadores Guarita", lightType: "normal", multipleInstances:[
      {x: 40.5, y: 72.5, width: 2.5, height: 5, circleNumber: 3},
      {x: 44, y: 71, width: 2.5, height: 5, circleNumber: 3},
      {x: 49.5, y: 74, width: 2.5, height: 5, circleNumber: 3},
      {x: 52, y: 71, width: 2.5, height: 5, circleNumber: 3},
      {x: 43, y: 83, width: 2.5, height: 5, circleNumber: 3},
      {x: 49.5, y: 85, width: 2.5, height: 5, circleNumber: 3},
      {x: 58, y: 85, width: 2.5, height: 5, circleNumber: 3},
    ]},
  { id: "grupo04", modulo: "1", idx: "4", descricao: "Balizadores Jardim", lightType: "normal", multipleInstances:[
    { x: 73, y: 81, width: 2.5, height: 5, circleNumber: 4 },
    { x: 77, y: 85, width: 2.5, height: 5, circleNumber: 4 },
    { x: 74.5, y: 75, width: 2.5, height: 5, circleNumber: 4 },
    { x: 85, y: 84, width: 2.5, height: 5, circleNumber: 4 },
    { x: 90, y: 76, width: 2.5, height: 5, circleNumber: 4 },
  ]},

  { id: "grupo05", modulo: "2", idx: "1", descricao: "Estac.Visitantes/Jardim", lightType: "normal", multipleInstances:[
    { x: 11, y: 72, width: 2.5, height: 5, circleNumber: 5 },
    { x: 15, y: 73, width: 2.5, height: 5, circleNumber: 5 },
    { x: 16, y: 80, width: 2.5, height: 5, circleNumber: 5 },
    { x: 20, y: 67, width: 2.5, height: 5, circleNumber: 5 },
    { x: 24, y: 67, width: 2.5, height: 5, circleNumber: 5 },
    { x: 27, y: 67, width: 2.5, height: 5, circleNumber: 5 },
    { x: 30, y: 67, width: 2.5, height: 5, circleNumber: 5 },
  
  ]},
  { id: "grupo06", modulo: "2", idx: "2", descricao: "Coqueiros", lightType: "normal", multipleInstances:[
    { x: 46, y: 86, width: 2.5, height: 5, circleNumber: 6 },
    { x: 54, y: 86, width: 2.5, height: 5, circleNumber: 6 },
    { x: 62, y: 86, width: 2.5, height: 5, circleNumber: 6 },
    { x: 79, y: 80, width: 2.5, height: 5, circleNumber: 6 },
    { x: 89, y: 81, width: 2.5, height: 5, circleNumber: 6 },
    { x: 92, y: 72, width: 2.5, height: 5, circleNumber: 6 },
  ]},
  { id: "grupo07", modulo: "2", idx: "3", descricao: "Jardim Acesso", lightType: "normal",  multipleInstances:[
    { x: 500, y: 26, width: 2.5, height: 5, circleNumber: 7 }
  ]},
  { id: "grupo08", modulo: "2", idx: "4", descricao: "Espelho dagua", lightType: "normal",  multipleInstances:[
    { x: 55.5, y: 69, width: 2.5, height: 5, circleNumber: 8 },
    { x: 59, y: 75, width: 2.5, height: 5, circleNumber: 8 },
  ]},

  { id: "grupo09", modulo: "3", idx: "1", descricao: "Logo",lightType: "normal",  multipleInstances:[
    { x: 58.5, y: 70, width: 2.5, height: 5, circleNumber: 9 },
  ]},
  { id: "grupo10", modulo: "3", idx: "2", descricao: "Hall Acesso Pendente", lightType: "normal", multipleInstances:[
    { x: 46, y: 64, width: 2.5, height: 5, circleNumber: 10 }
  ]},
  { id: "grupo11", modulo: "3", idx: "3", descricao: "Hall Acesso Teto", lightType: "normal", multipleInstances:[
    { x: 49, y: 67, width: 2.5, height: 5, circleNumber: 11 },

  ]},
  { id: "grupo12", modulo: "3", idx: "4", descricao: "Reserva", lightType: "normal", multipleInstances:[
    { x: 500, y: 0, width: 0, height: 0, circleNumber: 12 }
  ]},

  { id: "grupo13", modulo: "4", idx: "1", descricao: "Hall Social", lightType: "normal", multipleInstances:[
    { x: 50, y: 54, width: 2.5, height: 5, circleNumber: 13 },
    { x: 53.5, y: 52.5, width: 2.5, height: 5, circleNumber: 13 },
    { x: 55, y: 47, width: 2.5, height: 5, circleNumber: 13 },

  ]},
  { id: "grupo14", modulo: "4", idx: "2", descricao: "Jardim Garden Gourmet", lightType: "normal", multipleInstances:[
    { x: 77, y: 70, width: 2.5, height: 5, circleNumber: 14 },
    { x: 81, y: 74, width: 2.5, height: 5, circleNumber: 14 },
    { x: 87, y: 68, width: 2.5, height: 5, circleNumber: 14 },
    { x: 89, y: 60, width: 2.5, height: 5, circleNumber: 14 },
    { x: 82, y: 48, width: 2.5, height: 5, circleNumber: 14 },
    { x: 85.5, y: 45, width: 2.5, height: 5, circleNumber: 14 },

  ]},
  { id: "grupo15", modulo: "4", idx: "3", descricao: "Jardim Piscina Privativa", lightType: "normal", multipleInstances:[
    { x: 68.5, y: 42, width: 2.5, height: 5, circleNumber: 15 },
    { x: 74, y: 46, width: 2.5, height: 5, circleNumber: 15 },
    { x: 78, y: 50, width: 2.5, height: 5, circleNumber: 15 },
    { x: 83, y: 55, width: 2.5, height: 5, circleNumber: 15 },
    { x: 72, y: 36, width: 2.5, height: 5, circleNumber: 15 },
  ]},
  { id: "grupo16", modulo: "4", idx: "4", descricao: "Piscina Privativa", lightType: "normal", multipleInstances:[
    { x: 76, y: 39, width: 2.5, height: 5, circleNumber: 16 },
  ]},
  
  { id: "grupo17", modulo: "5", idx: "1", descricao: "Arandelas Garden Gourmet", lightType: "normal", multipleInstances:[
    { x: 86, y: 75, width: 2.5, height: 5, circleNumber: 17 },
    { x: 90, y: 65, width: 2.5, height: 5, circleNumber: 17 },
    { x: 88, y: 55, width: 2.5, height: 5, circleNumber: 17 },
    { x: 84, y: 41, width: 2.5, height: 5, circleNumber: 17 },
  ]},
  { id: "grupo18", modulo: "5", idx: "2", descricao: "L1 Jardim", lightType: "normal", multipleInstances:[
      {x: 34, y: 52, width: 2.5, height: 5, circleNumber: 18},
      {x: 37, y: 47, width: 2.5, height: 5, circleNumber: 18},
      {x: 40, y: 43, width: 2.5, height: 5, circleNumber: 18},
      {x: 43, y: 39, width: 2.5, height: 5, circleNumber: 18},
    ],
  },
  { id: "grupo19", modulo: "5", idx: "3", descricao: "Postes Piscina", lightType: "normal", multipleInstances:[
      {x: 33, y: 46, width: 2.5, height: 5, circleNumber: 19},
      {x: 39, y: 38, width: 2.5, height: 5, circleNumber: 19},

  ]},
  { id: "grupo20", modulo: "5", idx: "4", descricao: "Postes Piscina Adulto", lightType: "normal", multipleInstances:[
      {x: 10, y: 52, width: 2.5, height: 5, circleNumber: 20},
      {x: 12, y: 38, width: 2.5, height: 5, circleNumber: 20},

  ]},

  { id: "grupo21", modulo: "6", idx: "1", descricao: "Jardim Piscina Adulto", lightType: "normal", multipleInstances:[
      {x: 7, y: 61, width: 2.5, height: 5, circleNumber: 21},
      {x: 8, y: 46, width: 2.5, height: 5, circleNumber: 21},
      {x: 19, y: 29, width: 2.5, height: 5, circleNumber: 21},
      {x: 24, y: 28, width: 2.5, height: 5, circleNumber: 21},
      {x: 28, y: 27.2, width: 2.5, height: 5, circleNumber: 21},

  ]},
  { id: "grupo22", modulo: "6", idx: "2", descricao: "Floreira Piscina", lightType: "normal", multipleInstances:[
      {x: 7, y: 56, width: 2.5, height: 5, circleNumber: 22},
      {x: 9, y: 38, width: 2.5, height: 5, circleNumber: 22},
      {x: 10, y: 30, width: 2.5, height: 5, circleNumber: 22},

  ]},
  { id: "grupo23", modulo: "6", idx: "3", descricao: "Piscina Adulto", lightType: "normal", multipleInstances:[
      {x: 27, y: 40, width: 2.5, height: 5, circleNumber: 23},
      {x: 26, y: 49, width: 2.5, height: 5, circleNumber: 23},
      {x: 25.5, y: 58, width: 2.5, height: 5, circleNumber: 23},

  ]},
  { id: "grupo24", modulo: "6", idx: "4", descricao: "Jd Piscina Infantil/Perg Mães", lightType: "normal", multipleInstances:[
      {x: 42.5, y: 26, width: 2.5, height: 5, circleNumber: 24},
      {x: 45, y: 20, width: 2.5, height: 5, circleNumber: 24},
      {x: 47, y: 5, width: 2.5, height: 5, circleNumber: 24},
  ]},
  
  { id: "grupo25", modulo: "7", idx: "1", descricao: "Arandelas Piscina Infantil", lightType: "normal", multipleInstances:[
      {x: 28, y: 32, width: 2.5, height: 5, circleNumber: 25},
      {x: 33, y: 28, width: 2.5, height: 5, circleNumber: 25},
      {x: 37, y: 28, width: 2.5, height: 5, circleNumber: 25},

  ]},
  { id: "grupo26", modulo: "7", idx: "2", descricao: "Postes Perg Mães", lightType: "normal", multipleInstances:[
      {x: 46, y: 28, width: 2.5, height: 5, circleNumber: 26},
      {x: 62, y: 19, width: 2.5, height: 5, circleNumber: 26},
      {x: 51, y: 7, width: 2.5, height: 5, circleNumber: 26},
  ]},
  { id: "grupo27", modulo: "7", idx: "3", descricao: "Pergolado Mães", lightType: "normal", multipleInstances:[
      {x: 47, y: 11.5, width: 2.5, height: 5, circleNumber: 27},
  ]},
  { id: "grupo28", modulo: "7", idx: "4", descricao: "Quadra", lightType: "normal", multipleInstances:[
      {x: 55, y: 4, width: 2.5, height: 5, circleNumber: 28},
      {x: 69, y: 3, width: 2.5, height: 5, circleNumber: 28},
  ]},
  
  { id: "grupo29", modulo: "8", idx: "1", descricao: "Quadra 2", lightType: "normal", multipleInstances:[
      {x: 57, y: 14, width: 2.5, height: 5, circleNumber: 29},
      {x: 69, y: 13, width: 2.5, height: 5, circleNumber: 29},
  ]},
  { id: "grupo30", modulo: "8", idx: "2", descricao: "Cascata", x: 61.5, y: 73, width: 2.5, height: 5, circleNumber: 30, lightType: "normal" },
  { id: "grupo31", modulo: "8", idx: "3", descricao: "Hidromassagem Piscina Coberta", lightType: "normal",multipleInstances:[
      {x: 72.5, y: 26, width: 2.5, height: 5, circleNumber: 31},
      {x: 70, y: 30, width: 2.5, height: 5, circleNumber: 31},
  ]},
  { id: "grupo32", modulo: "8", idx: "4", descricao: "Cist Pot Painel Energizado", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 32, lightType: "normal" },
  
  { id: "grupo33", modulo: "9", idx: "1", descricao: "Cist Pot Alarme Falta de Fase", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 33, lightType: "normal" },
  { id: "grupo34", modulo: "9", idx: "2", descricao: "Cist Pot Satus Bomba 1", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 34, lightType: "normal" },
  { id: "grupo35", modulo: "9", idx: "3", descricao: "Cist Pot Status Bomba 2", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 35, lightType: "normal" },
  { id: "grupo36", modulo: "9", idx: "4", descricao: "Cist Pot Alarme Status Bomba 1", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 36, lightType: "normal" },
  
  { id: "grupo37", modulo: "10", idx: "1", descricao: "Cist Pot Alarme Status Bomba 2", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 37, lightType: "normal" },
  { id: "grupo38", modulo: "10", idx: "2", descricao: "Cx Água Pot Alarme Nível Alto", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 38, lightType: "normal" },
  { id: "grupo39", modulo: "10", idx: "3", descricao: "Bloqueador de Alarmes", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 39, lightType: "normal" },
  { id: "grupo40", modulo: "10", idx: "4", descricao: "Cist Plu Uso Potável", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 40, lightType: "normal" },
];

// Função útil para obter informações de ON/OFF para cada circuito
export const getCircuitOnOffValues = (circuitNumber) => {
  const circuitIndex = circuitNumber - 1;
  if (circuitIndex < 0 || circuitIndex >= iluminacaoConfig.length) {
    return null;
  }
  
  const circuit = iluminacaoConfig[circuitIndex];
  return {
    descricao: circuit.descricao,
    onValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "OFF" })
  };
};